import React from 'react';
import { FormattedMessage } from 'react-intl';
import NoData from '~/features/base/components/NoData';
import CommaSeparatedList from '~/features/base/components/CommaSeparatedList';

interface MmtPropertiesDeliverablesProps {
    mmtProperties?: {
        vehicleEnergyTypes?: string[];
        mmtHeadUnits?: string[];
        mmtFunctions?: string[];
    };
}

const MmtPropertiesDeliverables: React.FC<MmtPropertiesDeliverablesProps> = ({
    mmtProperties
}) => {
    const vehicleEnergyTypes = mmtProperties?.vehicleEnergyTypes;
    const mmtHeadUnits = mmtProperties?.mmtHeadUnits;
    const mmtFunctions = mmtProperties?.mmtFunctions;
    if (!vehicleEnergyTypes && !mmtHeadUnits && !(mmtFunctions && mmtFunctions.length > 0)) {
        return <NoData/>;
    }

    return (
        <div>
            {vehicleEnergyTypes && vehicleEnergyTypes.length > 0 && <div className={'word-break'}>
                <label><FormattedMessage id='intl-msg:vehicleEnergyType'/>:</label>{' '}
                <CommaSeparatedList>{vehicleEnergyTypes}</CommaSeparatedList>
            </div>}
            {mmtHeadUnits && mmtHeadUnits.length > 0 && <div className={'word-break margin-top-10 margin-bottom-10'}>
                <label><FormattedMessage id='intl-msg:mmtHeadUnit'/>:</label>{' '}
                <CommaSeparatedList>{mmtHeadUnits}</CommaSeparatedList>
            </div>}
            {mmtFunctions && mmtFunctions.length > 0 && (
                <div className={'word-break'}>
                    <label><FormattedMessage id='intl-msg:mmtFunctions' />:</label>{' '}
                    <CommaSeparatedList>{mmtFunctions}</CommaSeparatedList>
                </div>
            ) }
        </div>
    );
};

export default MmtPropertiesDeliverables;
